a<template lang="pug">
	.sidebar-content(:class="{'has-subscription': hasSubscription}")
		.sidebar-content-border
		.logo(v-if="!hasSubscription")
			a(href="/")
				img(:src="`${$store.state.config.s3ResourceHost}/images/redesign-v1/logos/logos-sfc-primay-blue.svg`" alt="SFC Logo")
		.navigation-elements
			.navigation-element(:class="{'active': internalLearnUrl($route.path), 'with-margin': !hasSubscription }" @click="goToPage('/savings-center/learn/how-much-will-college-cost')")
				.active-border
				.navigation-image
					img(:src="`${$store.state.config.s3ResourceHost}/images/icon-books-apple.svg`" alt="Learn")
				.navigation-title LEARN
				.navigation-copy(:class="{'hidden': !showText}") I want to learn more about college savings
			.navigation-element(:class="{'active': ($route.path == '/savings-center/open-a-plan') || ($route.path == '/savings-center/open-a-plan/compare') }" @click="goToPage('/savings-center/open-a-plan')")
				.active-border
				.navigation-image
					img(:src="`${$store.state.config.s3ResourceHost}/images/icon-open-plan.svg`" alt="Open a plan")
				.navigation-title OPEN A PLAN
				.navigation-copy(:class="{'hidden': !showText}") I'm ready to open a 529 plan
			.navigation-element(:class="{'active': $route.path == '/savings-center/grow' }" @click="goToPage('/savings-center/grow')")
				.active-border
				.navigation-image
					img(:src="`${$store.state.config.s3ResourceHost}/images/icon-grow.svg`" alt="Grow")
				.navigation-title GROW
				.navigation-copy(:class="{'hidden': !showText}") I want to accelerate my 529 plan savings
			// .navigation-element(:class="{'active': $route.path == '/savings-center/track' }" @click="goToPage('/savings-center/track')")
				.active-border
				.navigation-image
					img(:src="`${$store.state.config.s3ResourceHost}/images/icon-track-dashboard.svg`" alt="Track")
				.navigation-title TRACK
				.navigation-copy(:class="{'hidden': !showText}") I want to connect and monitor my 529 plan


</template>


<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.mobile-manage-account-icon
		z-index: 1000
		position: fixed
		top: 14px
		right: 10px
		display: none
		@media(max-width: 991px)
			display: none

	.sidebar-content
		height: 100%
		overflow-y: auto
		width: 200px
		background-color: #fff
		padding-top: 20px
		padding-bottom: 20px
		text-align: center
		z-index: 200
		@media(max-width: 991px)
			width: 100%
			padding: 0
			overflow: hidden
			.navigation-copy
			.manage-account
			.logo
				display: none

		&.has-subscription
			padding-top: 60px

	.sidebar-content-border
		position: absolute
		height: 100%
		width: 2px
		right: 0
		top: 0
		background: #ebeef4
		@media(max-width: 991px)
			position: absolute
			height: 2px
			width: 100%
			left: 0
			top: 0

	.logo
		padding: 5px 10px

	.navigation-elements
		@media(max-width: 991px)
			margin: auto
			max-width: 500px
			display: flex

	.active-border
		width: 3px
		background-color: sfc-royal-blue
		height: 100%
		position: absolute
		right: 0
		top: 0
		@media(max-width: 991px)
			width: 100%
			height: 2px
			left: 0
			top: 0

	.navigation-element
		position: relative
		padding-top: 12px
		padding-bottom: 12px
		cursor: pointer
		.active-border
			display: none
		&.with-margin
			margin-top: 20px

		&:hover
		&.active
			.active-border
				display: block

		@media(max-width: 991px)
			flex: 1
			padding: 0
			&.with-margin
				margin-top: 0

	.navigation-image
		width: 35px
		margin: auto
		img
			width: 100%
		@media(max-width: 991px)
			width: 35px
			height: 32px
			img
				width: 100%
				height: 100%

	.navigation-image
		margin-top: 10px

	.navigation-title
		margin-top: 10px
		font-size: body-font-size-md
		font-weight: body-font-weight-strong
		@media(max-width: 991px)
			font-size: body-font-size
			margin-top: 7px
		@media(max-width: 575px)
			font-size: body-font-size-xxs

	.navigation-copy
		line-height: body-font-line-height-sm
		color: sfc-pale-gray
		font-size: body-font-size-sm
		margin: auto
		width: 70%
		&.hidden
			display: none

	.manage-account
		margin-top: 40px
		.separator
			padding-top: 10px
			border-top: 1px solid #ebeef4
			width: 80%
			margin: auto
		img
			vertical-align: middle
		.text
			color: sfc-pale-gray
			font-size: body-font-size
			vertical-align: middle
			display: inline-block
			margin-left: 10px
</style>

<script>
	import Vue from 'vue'
	import SfcOnboardingModalV3 from '@/common/components/savings-center/v3/onboarding/modal-v3'
	export default {
			components: {
				SfcOnboardingModalV3
			},
		data(){
			return {
				showText: true,
				savingsCenterFlow:false,
				updateEmailDrawerOpened: false,
				logoutUrl: '/logout/'
			}
		},
		computed: {
			isGold(){
				if (this.$store.state.sfcSubscriptions && (this.$store.state.sfcSubscriptions.is_gold_member || this.$store.state.sfcSubscriptions.is_admin_member)) {
					return true
				}
				return false
			},

			isPlatinium(){
				if (this.$store.state.sfcSubscriptions && (this.$store.state.sfcSubscriptions.is_platinium_member || this.$store.state.sfcSubscriptions.is_admin_member)) {
					return true
				}
				return false
			},

			hasSubscription(){
				return this.isGold || this.isPlatinium
			}
		},
		mounted(){
			this.handleResize()
			window.addEventListener('resize', this.handleResize);
			this.logoutUrl = `/logout/?return_url=${window.location.href}`
		},
		methods:{
			handleResize(){
				if(window.innerHeight < 780){
					this.showText = false
					return
				}
				this.showText = true
			},
			goToPage(page){
				this.$router.push(page)
			},
			openModal(){
				setTimeout( () => {
						this.$sfcModal.open("sfc-onboarding-modal-v3-3", {title: "Account Settings"})
				}, 0)
			},
			setReadyToTriggerOnExit(){
				if(!this.$store.state.userIsLoggedIn){
					setTimeout( () => {
						this.readyToTriggerOnExit = true
					}, 15000)
				}
			},
			onLeave () {
				// This is no the best way, but we have no class for those elements
				for(let id = 0; id < 40; id++){
					let element = document.getElementById(`sfc-widget-id-${id}`)
					if(element){
						let style = element.getAttribute("style")
						if(style.indexOf("inline-block") != -1){
							this.trackCollision()
						}
					}
				}
				this.$refs.exitModalTrigger.click()
			},
			internalLearnUrl(path){
				let internalUrls = [
					// '/savings-center/learn',
					'/savings-center/learn/how-much-will-college-cost',
					'/savings-center/learn/how-much-should-i-save-for-college',
					'/savings-center/learn/what-are-my-college-savings-options',
					'/savings-center/learn/what-is-a-529-plan',
					'/savings-center/learn/how-do-529-plans-work',
					'/savings-center/faq/does-a-529-plan-affect-financial-aid',
					'/savings-center/faq/can-i-have-529-plans-from-multiple-states',
					'/savings-center/faq/are-529-plans-only-for-my-state-public-colleges',
					'/savings-center/faq/what-is-the-penalty-on-an-unused-529-plan',
					'/savings-center/faq/529-savings-plans-and-private-school-tuition',
					'/savings-center/faq/how-do-i-select-the-right-investments-for-my-529-plan',
					'/savings-center/faq/what-you-can-pay-for-with-a-529-plan',
					'/savings-center/faq/where-to-start-when-choosing-a-529-plan',
					'/savings-center/faq/how-to-select-a-529-plan'
				]
				return internalUrls.indexOf(path) > -1
			}
		}
	}
</script>
